import BillingPaymentBlockCard from './billing-payment-block-card';

export default BillingPaymentBlockCard;
